import store from "@frameworks/web/redux/store";
import { LOGIN_DATA, LOGIN_ERROR_DATA, LOGIN_HIDE_ERROR_DATA, LOGIN_START_LOADER, LOGIN_STOP_LOADER, } from "../interface/iClientLoginData";
export default class ClientLoginDataAction {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getLoginData(data) {
        this.dispatch({
            type: LOGIN_DATA,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: LOGIN_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: LOGIN_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: LOGIN_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: LOGIN_STOP_LOADER,
        });
    }
}
